// import React from 'react';

// const AIMLSolution = () => {
//   return (
//     <div style={styles.container} className="aiml-container">
//       <div style={styles.textSection} className="textSection">
//           <h2 style={styles.title} className="title">Unlocking the Power of Your Data</h2>
//           <p style={styles.description} className="description">
//             We help businesses leverage data to gain a competitive edge through seamless integration, transformation, and actionable insights.
//           </p>
//           <p style={styles.description} className="description">
//             Data engineering is the backbone of any successful data strategy. We focus on building robust, scalable, and efficient data pipelines that gather, store, and process data from various sources.
//           </p>
//           <p style={styles.description} className="description">
//             Through advanced analytics techniques like machine learning, statistical analysis, and data mining, we extract valuable insights to support decision-making processes.
//           </p>
//           <p style={styles.description} className="description">
//             Our team uses cutting-edge technologies like Hadoop, Spark, SQL, and cloud platforms like AWS and Azure to build efficient data infrastructure.
//           </p>
//         </div>

//       <div style={styles.imageSection} className="aiml-image">
//         <img 
//           src="/image/data-engineering-about.png" 
//           alt="AI/ML Solutions" 
//           style={styles.image} 
//           onError={(e) => {
//             e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZTVlNWU1Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJtb25vc3BhY2UiIGZvbnQtc2l6ZT0iMjBweCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkFJL01MIElsbHVzdHJhdGlvbjwvdGV4dD48L3N2Zz4=';
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     display: 'flex',
//     flexDirection: 'row',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: 'clamp(20px, 5vw, 60px) clamp(15px, 4vw, 40px)',
//     backgroundColor: 'white',
//     boxSizing: 'border-box',
//     minHeight: '70vh',
//     color: 'black',
//     gap: 'clamp(20px, 4vw, 40px)',
//     flexWrap: 'wrap',
//   },
//   textSection: {
//     flex: '1 1 500px',
//     minWidth: '300px',
//     textAlign: 'left',
//   },
//   title: {
//     fontSize: 'clamp(24px, 4vw, 36px)',
//     fontWeight: 'bold',
//     marginBottom: '20px',
//     color: 'black',
//     lineHeight: '1.3',
//     letterSpacing:"0px",
//   },
//   description: {
//     fontSize: 'clamp(14px, 1.8vw, 16px)',
//     lineHeight: '1.6',
//     marginBottom: '15px',
//     textAlign: 'left',
//     color: 'black',
//   },
//   imageSection: {
//     flex: '1 1 400px',
//     minWidth: '300px',
//     textAlign: 'center',
//   },
//   image: {
//     width: '100%',
//     height: 'auto',
//     maxWidth: '600px',
//     borderRadius: '8px',
//     boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//     objectFit: 'contain',
//   },
// };

// // Media queries using a style tag for broader compatibility
// const mediaQueries = `
//   @media screen and (max-width: 1024px) {
//     .aiml-container {
//       flex-direction: column;
//       text-align: center;
//     }
//     .aiml-text, .aiml-image {
//       width: 100% !important;
//       text-align: center;
//       padding: 0;
//     }
//     .aiml-text {
//       text-align: center;
//     }
//     .aiml-text p {
//       text-align: center;
//     }
//     .aiml-image img {
//       margin: 0 auto;
//       max-width: 90%;
//     }
//   }

//   @media screen and (max-width: 768px) {
//     .aiml-container {
//       padding: 30px 15px;
//       gap: 25px;
//     }
//     .aiml-text h2 {
//       font-size: 28px !important;
//     }
//   }

//   @media screen and (max-width: 480px) {
//     .aiml-container {
//       padding: 20px 10px;
//       gap: 20px;
//     }
//     .aiml-text h2 {
//       font-size: 22px !important;
//       line-height: 1.3;
//       margin-bottom: 15px;
//     }
//     .aiml-text p {
//       font-size: 14px !important;
//       line-height: 1.5;
//       margin-bottom: 12px;
//       text-align: left;
//     }
//     .aiml-image img {
//       max-width: 100%;
//     }
//   }
// `;

// // Add media queries to document
// if (typeof document !== 'undefined') {
//   const styleSheet = document.createElement('style');
//   styleSheet.textContent = mediaQueries;
//   document.head.appendChild(styleSheet);
// }

// export default AIMLSolution;





import React from "react";
import { motion } from "framer-motion";

const AIMLSolution = () => {
  // Animation variants
  const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.3, // each paragraph comes one by one
        duration: 0.8,
        ease: "easeOut",
      },
    }),
  };

  const paragraphs = [
    "We help businesses leverage data to gain a competitive edge through seamless integration, transformation, and actionable insights.",
    "Data engineering is the backbone of any successful data strategy. We focus on building robust, scalable, and efficient data pipelines that gather, store, and process data from various sources.",
    "Through advanced analytics techniques like machine learning, statistical analysis, and data mining, we extract valuable insights to support decision-making processes.",
    "Our team uses cutting-edge technologies like Hadoop, Spark, SQL, and cloud platforms like AWS and Azure to build efficient data infrastructure.",
  ];

  return (
    <div style={styles.container} className="aiml-container">
      <div style={styles.textSection} className="textSection">
        <motion.h2
          style={styles.title}
          className="title"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          Unlocking the Power of Your Data
        </motion.h2>

        {paragraphs.map((text, i) => (
          <motion.p
            key={i}
            style={styles.description}
            className="description"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            custom={i}
            viewport={{ once: true, amount: 0.2 }}
          >
            {text}
          </motion.p>
        ))}
      </div>

      <motion.div
        style={styles.imageSection}
        className="aiml-image"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: "easeOut", delay: 1 }}
        viewport={{ once: true }}
      >
        <img
          src="/image/data-engineering-about.png"
          alt="AI/ML Solutions"
          style={styles.image}
          onError={(e) => {
            e.target.src =
              "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZTVlNWU1Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJtb25vc3BhY2UiIGZvbnQtc2l6ZT0iMjBweCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkFJL01MIElsbHVzdHJhdGlvbjwvdGV4dD48L3N2Zz4=";
          }}
        />
      </motion.div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "clamp(20px, 5vw, 60px) clamp(15px, 4vw, 40px)",
    backgroundColor: "white",
    boxSizing: "border-box",
    minHeight: "70vh",
    color: "black",
    gap: "clamp(20px, 4vw, 40px)",
    flexWrap: "wrap",
  },
  textSection: {
    flex: "1 1 500px",
    minWidth: "300px",
    textAlign: "left",
  },
  title: {
    fontSize: "clamp(24px, 4vw, 36px)",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "black",
    lineHeight: "1.3",
    letterSpacing: "0px",
  },
  description: {
    fontSize: "clamp(14px, 1.8vw, 16px)",
    lineHeight: "1.6",
    marginBottom: "15px",
    textAlign: "left",
    color: "black",
  },
  imageSection: {
    flex: "1 1 400px",
    minWidth: "300px",
    textAlign: "center",
  },
  image: {
    width: "100%",
    height: "auto",
    maxWidth: "600px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    objectFit: "contain",
  },
};

export default AIMLSolution;
